import PropTypes from 'prop-types';
import React from 'react';


const CoverSection = ({ image, text }) => (
  <div className="landing-page__cover-section" style={ { backgroundImage: `url(${image})` } }>
    <header className="landing-page__cover-section__overlay">
      <h1 className="landing-page__cover-section__claim">
        { text }
      </h1>
    </header>
  </div>
);

CoverSection.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default CoverSection;
